export const ShareIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.13632 3.13623H2.04528C1.74424 3.1365 1.50026 3.38047 1.5 3.68151V12.9546C1.50026 13.2557 1.74424 13.4996 2.04528 13.4999H11.3184C11.6194 13.4996 11.8634 13.2557 11.8637 12.9546V5.86359"
        stroke="#FC4C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.68164 8.3184L13.5 1.5"
        stroke="#FC4C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.68213 1.5H13.5V5.3184"
        stroke="#FC4C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
